export default "__VITE_ASSET__Dbdz4j5p__"